<template>
  <div class="new-view-empty">
    <div class="top">
      <div class="bubble bubble-mid">{{ showEnum[type].mid }}</div>
      <div class="bubble bubble-left">{{ showEnum[type].left }}</div>
      <div class="bubble bubble-right">{{ showEnum[type].right }}</div>
      <i class="icon-sparkling-2-fill t-iconfont"></i>
      <img alt="" :src="aiLogo" />
    </div>
    <div class="desc" v-html="showEnum[type].desc"></div>
    <div class="btn" @click="handleClickCreate">
      <i class="icon-sparkling-2-fill t-iconfont"></i>
      <span>{{ showEnum[type].btn }}</span>
    </div>
  </div>
</template>

<script setup>
import aiLogo from '@/assets/chatbot.svg'
// import aiLogo from '@/assets/logo.svg'

const props = defineProps({
  type: {
    type: String,
    default: 'customer'
  }
})

const emit = defineEmits(['create'])

const showEnum = {
  customer: {
    left: '决策链',
    mid: '客户全貌',
    right: '风险点',
    desc: `Al 基于历史跟进，智能提炼客户全貌、决策链、风险点<br>帮你理清客户现状，给出下一步跟进动作，高效赢单`,
    btn: '生成客户分析报告'
  },
  opportunity: {
    left: '赢单概率',
    mid: '核心卡点',
    right: '攻坚策略',
    desc: `看清赢单概率、核心卡点、攻坚策略<br>每一步推进都更有把握`,
    btn: '生成商机分析报告'
  },
  clue: {
    left: '真实需求',
    mid: '转化潜力',
    right: '破冰策略',
    desc: `识别真实需求、判断转化潜力、给出破冰策略<br>不浪费每一条线索，助力线索高效转化`,
    btn: '生成线索分析报告'
  }
}

const handleClickCreate = () => {
  emit('create', props.type)
}
</script>

<style lang="scss" scoped>
$new-view-bg: #f7f8fa;
$new-view-border: #f2f3f5;
$bubble-bg: #f5e8ff;
$bubble-color: #7a52f4;
$face-bg: #00031a;
$shadow-bg: rgba(0, 0, 0, 0.12);
$highlight-gradient: linear-gradient(314deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
$btn-bg: linear-gradient(282deg, #eef2ff 1%, #f5f3ff 100%);
$btn-border: rgba(124, 58, 237, 0.15);

.new-view-empty {
  flex: 1;
  background: $new-view-bg;
  box-sizing: border-box;
  border: 1px solid $new-view-border;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .top {
    position: relative;
    width: 340px;
    height: 170px;
    display: flex;
    justify-content: center;
    align-items: end;
    margin-bottom: 16px;
    img {
      height: 112px;
    }
    .icon-sparkling-2-fill {
      position: absolute;
      top: 62px;
      right: 128px;
      font-size: 20px;
      background: $highlight-gradient;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }
  }
  .desc {
    width: 340px;
    font-size: 14px;
    line-height: 20px;
    color: #646566;
    text-align: center;
    font-size: 14px;
    margin-bottom: 16px;
  }

  .bubble {
    position: absolute;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 34px;
    padding: 8px 16px;
    box-sizing: border-box;
    border-radius: 16px;
    background: $bubble-bg;
    color: $bubble-color;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    box-shadow: 0 2px 4px 2px rgba(22, 0, 77, 0.05);
  }

  .bubble-mid {
    top: 8px;
    left: 116px;
  }

  .bubble-left {
    top: 80px;
    left: 24px;
    box-shadow: 0 2px 8px 2px rgba(22, 0, 77, 0.1);
  }

  .bubble-right {
    top: 58px;
    right: 24px;
  }

  .btn {
    width: 150px;
    height: 34px;
    margin-top: 20px;
    box-sizing: border-box;
    border: 1px solid $btn-border;
    border-radius: 12px;
    background: $btn-bg;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    cursor: pointer;

    .icon-sparkling-2-fill {
      font-size: 14px;
      margin-right: 8px;
      background: $highlight-gradient;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }

    span {
      font-size: 13px;
      line-height: 18px;
      white-space: nowrap;
      background: $highlight-gradient;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }
  }
}
</style>
